
import { WDFormInput } from './wd-form-input';
import WDDropdown from '../dropdown/wd-dropdown';
import WDDropdownAccordion from '../dropdown/wd-dropdown-accordion';
import WDUtil from '../../core/wd-util';
import WDDropdownForm from '../dropdown/wd-dropdown-form';

export class WDFormTextselect extends WDFormInput
{
  #dropdown = null;
  #lastKeyedUp = null;
  #prefixFilter;

  constructor(opts)
  {
    const settings = {
      templates: {
        label: '${label}',
        value: '${value}',
      }
    };

    WDUtil.merge(settings, opts);

    //don't let the parent set the value just yet
    const useValue = settings?.value !== undefined ? settings.value : null;
    delete (settings.value);

    //tell the browser we are input=text and stop autocomplete totally
    settings.type = 'text';
    settings.autodisabled = true;
    super(settings);

    this.input.addEventListener('keyup', (evt) => this.handleKeyUp(evt));
    this.input.addEventListener('keydown', (evt) => this.handleKeyDown(evt));
   
    this.input.addEventListener('focusin', (evt) => {
      //if we get here by something other than click then we should show
      //the dropdown, but give bootstrap a chance to handle it first
      setTimeout(() => this.dropdownShow(), 250)
    });
    
  
    //we will manage this ourselves
    this.input.addEventListener('change', (evt) => {
      if (this.input.value == '') 
      {
        this.value = null;
      }
      evt.preventDefault();
      evt.cancelBubble = true;
    } );
  };

  connectedCallback()
  {
    super.connectedCallback();
    const dd = this.dropdown;
    if (this.config.prefixFilter) 
    {
      const pf = this.prefixFilter;
    }
  };

  get readonly() { return super.readonly;};
  set readonly(val)
  {
    super.readonly = val;

    if (val == true) this.deactivateDropdown();
    else this.activateDropdown();
  };

  get dropdown()
  {
    if (!this.#dropdown)
    {
      //form passes .proxy, but dropdowns use uriData to resolve templated uris
      if (this.config?.model) this.config.uriModel = this.config?.model;

      if (this.config?.groupField)
      {
        this.#dropdown = new WDDropdownAccordion(this.config);
      }
      else
      {
        this.#dropdown = new WDDropdown(this.config);
      }

      this.#dropdown.on('items:added', (evt) => this.handleOptionsSet(evt));
      this.inputGroup.append(this.#dropdown);
      
      if (!this.config?.readonly) this.activateDropdown();
      
      this.#dropdown.on('item:selected', (evt) => this.value = evt.detail.model);
      this.#dropdown.on('keyup', evt => this.handleDropdownKeyUp(evt));

      //
      const passThruEvents = ['change', 'item:added', 'items:added', 'model:set', 'value:set'];
      passThruEvents.forEach(evtName =>
      {
        this.#dropdown.on(evtName, (evt) => this.trigger(evtName, evt.detail));
      });

      this.#dropdown.on('model:set', (evt) => this.trigger('options:set', evt));
    }

    return this.#dropdown;
  }

  activateDropdown()
  {
    this.input.classList.add('dropdown-toggle');
    this.input.dataset.bsToggle = 'dropdown';
    this.input.dataset.bsAutoClose = 'outside';
  }

  deactivateDropdown()
  {
    this.input.classList.remove('dropdown-toggle');
    delete (this.input.dataset.bsToggle);
    delete (this.input.dataset.bsAutoClose);
  }

  runSelectFirstOption()
  {
    if (this.options.length > 0)
    {
      //grouped, pull the first item from the first nonempty option
      if (this.config?.groupField)
      {
        let val = null;
        this.options.some( opt => {
          if (opt.items.length > 0)
          {
            val = opt.items[0];
            return true;
          }
        });

        this.value = val;
        this.dropdown.hide();
      }
      else
      {
        this.value = this.options[0];
        this.dropdown.hide();
      }
     
    }

  }

  selectFirstOption()
  { 
    if (this.dropdown.isFetching == true)
    {
      this.dropdown.once('model:fetched', () => this.runSelectFirstOption());
    }
    else
    {
      this.runSelectFirstOption();
    }
  };

  /**
   * 
   * bootstrap dropdown workaround.  Bootstrap captures arrowdown and up keydown events
   * so we use keyup to figure out when the user has hit the up arrow while focused on
   * the first list item to get back to the text box for more searching 
   */
  handleDropdownKeyUp(evt)
  {
    if (evt.key == 'ArrowUp')
    {
      if (this.#lastKeyedUp == this.dropdown.firstItem)
      {
        this.input.focus();
        evt.preventDefault();
      }
    }

    this.#lastKeyedUp = document.activeElement;
  }

  handleKeyDown(evt)
  {
    if (this.readonly) 
    {
      evt.preventDefault();
      return;
    }
    
    if (evt.key == 'ArrowDown')
    {
      //stop the dropdown from scrolling down
      evt.preventDefault();

      //advance down to the first item in the dropdown
      if (this.options.length > 0 && document.activeElement == this.input)
      {
        this.dropdownShow();
        const firstItem = this.dropdown.querySelector('[tabindex="-1"]');
        if (firstItem) firstItem.focus();  
      }
    }
    else if (evt.key == 'Enter')
    {
      evt.preventDefault();
      if (this.options.length > 0) this.selectFirstOption();
    }
  };

  // Override parent's handleKeyUp to use this.value instead of this.data
  handleKeyUp(evt)
  {
    if (this.readonly) return;

    // Check if the key is alphanumeric (letters, numbers, space, or common punctuation for search)
    const isAlphanumeric = /^[a-zA-Z0-9\s\-_\.@#]$/.test(evt.key);

    if (isAlphanumeric)
    {
      this.dropdown.filter(this.input.value);
      this.dropdownShow();
    }
    // If Backspace is pressed and input is empty, set value to null
    else if (evt.key === 'Backspace' && this.input.value.trim() === '')
    {
      this.value = null;
      this.dropdown.filter('');
      this.dropdownShow();
    }
  }

  dropdownShow()
  {
    if (!this.#dropdown.classList.contains('show') && this.options.length > 0 && !this.readonly)
    {
      this.#dropdown.show();
    }
  };

  dropdownHide()
  {
    if (this.#dropdown.classList.contains('show'))
    {
      this.#dropdown.hide();
    }
  };

  handleOptionsSet(evt)
  {
    this.trigger('items:added');
    if (this.options.length > 0 && !this.readonly) this.activateDropdown();
    else this.deactivateDropdown();
  };

  /**
   * Ensures the dropdown is still focused when it is shown and the options have been updated
   */
  checkDropdownFocus()
  {
    setTimeout(() =>
    {
      // Check if current focus is within our dropdown, if not focus first item
      const activeElement = document.activeElement;
      //const isInDropdown = this.dropdown.contains(activeElement);

      if (activeElement != this.input && !this.dropdown.contains(activeElement))
      {
        this.dropdown.firstItem.focus();
      }
    }, 10);
  }

  get options() { return this.dropdown.model; };
  set options(newOptions) { return this.dropdown.model = newOptions; };
  get fetch() { return this.dropdown.fetch; };
  set fetch(f) { this.dropdown.fetch = f; };
  set fetchURI(uri) { return this.dropdown.fetchURI = uri; };
  fetchOptions() { return this.dropdown.fetchModel(); };
  runFetch() { return this.dropdown.fetchModel(); };

  get value() { return this.input.value; };
  set value(val)
  {
    const origVal = this.input.value;

    if (val === null)
    {
      this.input.value = '';
    }
    //if the dropdown is clicked, we end up here
    else if (typeof (val) == 'object')
    {
      this.input.value = this.config.templates.value.interpolate(val);
    }
    else
    {
      this.input.value = val;
    }

    this.trigger('value:set');

    if (origVal != this.input.value) 
    {
      this.trigger('change');
    }
  
  }

  get prefixFilter()
  {
    if (!this.#prefixFilter)
    {
      const cfg = this.config.prefixFilter;

      this.#prefixFilter = new WDDropdownForm(cfg);
      this.prefix.append(this.#prefixFilter);
      this.prefix.classList.add('has-filter');
      this.#prefixFilter.on('change',() => {

        if (this.#prefixFilter.value !== null) this.fetch[cfg.name] = this.#prefixFilter.value;
        else delete(this.fetch[cfg.name]);
      
        this.#dropdown.fetchModel();
      });
    }

    return this.#prefixFilter;
  }

};

customElements.define('wd-form-textselect', WDFormTextselect);
